import { FC, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Autoplay } from 'swiper/core';
import { getNameByKey } from '../../../../../lib/utils/UtilsCommon';
import 'swiper/swiper.less';
import './style.less';

SwiperCore.use([Autoplay]);

interface IProps {
	classNames?: string;
}
/** 品牌报道 */
const BrandReport: FC<IProps> = ({ classNames }) => {
	const swipeRef = useRef(null);
	const list = [
		{
			channelImg:
				'https://media.qianliaowang.com/xqd/tools/activity/image/2025112011/2WUTG19V-2SEY-ST3F-1763622655956-EXDDTB2XMOPR.png?x-oss-process=image/format,webp',
			title: '人民日报报道兴趣岛“乡村图书室”公益计划，在国际儿童图书日给乡村孩子送去特别礼物',
			content:
				'4月2日，国际儿童图书日，兴趣岛第二所“爱心图书室”在湖南桂阳正式揭牌启用，获人民日报关注报道。这也是兴趣岛践行“为人们构建起一所激发生命热爱的精神乐园”这一使命的又一次落地。',
			link: 'https://www.peopleapp.com/column/30051793459-500007424047',
		},
		{
			channelImg:
				'https://media.qianliaowang.com/xqd/tools/activity/image/2026073111/IHV9SO8B-CEKI-WP2Y-1785476568239-M9WOSY2IVRH6.png?x-oss-process=image/format,webp',
			title: '新华社聚焦兴趣岛《人生有“趣”处——乐龄族兴趣学习心理洞察报告》',
			content:
				'新华社聚焦兴趣岛乐龄心理报告：兴趣学习被指为养老痛点“破局之钥”，加速“物质供养”向“精神康养”转型。',
			link:
				'https://h.xinhuaxmt.com/vh512/share/13145680?docid=13145680&newstype=1001&d=1352703&channel=weixin',
		},
		{
			channelImg:
				'https://media.qianliaowang.com/xqd/tools/activity/image/2026013011/67RFPKDQ-ITMU-D5N3-1769774726951-2SM6W36D5RCQ.png',
			title: '中国日报报道2026兴趣岛艺术节，推动养老模式从“物质供养”迈向“精神康养”',
			content:
				'6月28日-28日，2026兴趣岛艺术节获中国日报关注报道。报道指出，兴趣学习为银发群体搭建了展示自我、连接同好的平台。',
			link: 'https://gd.chinadaily.com.cn/a/202607/02/WS6a45f551a310d709c2fbb7be.html',
		},
		{
			channelImg:
				'https://media.qianliaowang.com/xqd/tools/activity/image/2026013011/C2OJJEDY-DM7O-8OCH-1769772957670-4S4W8YJ5CHJ1.png',
			title: '光明日报报道321首个“国际太极拳日”师生展演活动',
			content:
				'3月21日，在首个“国际太极拳日”，兴趣岛师生展演活动获光明日报报道。报道评价称，兴趣岛打造非遗太极的银发传承样本。',
			link: 'https://app.gmdaily.cn/as/opened/n/edfde0cc661841bd9c2b89ab0dae4b9d',
		},
		{
			channelImg:
				'https://media.qianliaowang.com/xqd/tools/activity/image/2025112011/W97SAEB4-Q7YO-FV4S-1763626434861-NQY2PLRSYWMT.png?x-oss-process=image/format,webp',
			title: '银发兴趣教育如何定义“高质量”？兴趣岛荣获全国质量月质量诚信倡议企业',
			content:
				'2025年10月，在国家市场监督管理总局等26部门联合开展的全国“质量月”活动中，兴趣岛凭借在银发兴趣教育领域对师资筛选、课程研发与服务体系的全链条高质量把控，获得中国质量检验协会颁发的两项荣誉：“全国质量月质量诚信倡议企业” 和 “全国产品和服务质量诚信品牌”。',
			link: 'http://www.chinatt315.org.cn/rdgz/2025-11/11/257408.html',
		},
		{
			channelImg:
				'https://media.qianliaowang.com/xqd/tools/activity/image/2025112011/2WUTG19V-2SEY-ST3F-1763622655956-EXDDTB2XMOPR.png?x-oss-process=image/format,webp',
			title: '重阳节，《乐龄族兴趣生活方式图鉴》广州发布',
			content:
				'2025年10月29日，重阳佳节，兴趣岛发布聚焦40-70岁人群兴趣生活的《乐龄族兴趣生活方式图鉴》，并同步揭牌成立兴趣生活研究院，获得人民日报记者关注报道。这份图鉴，通过平台超3500万用户的数据调研，描绘了当代乐龄群体突破年龄界限、通过兴趣学习重塑生活方式的新图景。',
			link: 'https://www.peopleapp.com/column/30050631310-500007173063',
		},
		{
			channelImg:
				'https://media.qianliaowang.com/xqd/tools/activity/image/2025061211/SM4SIVHW-9B5M-LV7P-1749695996166-WJOWWOGYNQYK.png?x-oss-process=image/format,webp',
			title: '广州打造银发消费IP 与兴趣岛等领军企业共推银发经济发展',
			content:
				'6月3日，央级媒体消费日报发布报道，讲述兴趣岛受邀出席日前举办的广州首届银龄艺术季启动仪式暨天河区选拔赛，并助力本届艺术季举办。现场，兴趣岛副总裁林景接受广东电视台采访，天河区领导一行参观兴趣岛展台并进行工作指导。消费日报指出，兴趣岛与银龄艺术季的合作模式，已然成为推动银发经济发展的全新范式。',
			link: 'http://www.xfrb.com.cn/article/council/15291510638980.html',
		},
		{
			channelImg:
				'https://img.qlchat.com/xqd/tools/activity/image/2025090211/E1POGY8Z-5ZLZ-DLEE-1756785374797-UAC63YZN5XSH.png',
			title: '满足高品质养老需求 业界打造全新兴趣生活体验',
			content:
				'8月28日，央媒人民网发布报道，讲述兴趣岛广州城市中心的落成，是兴趣岛从线上迈向线上线下融合发展的关键一步，更是对“让兴趣滋养生活”理念的重要践行。人民网指出，兴趣岛结合用户服务体验的洞察，打造“线上学习+线下参与”的一站式兴趣学习方式，把兴趣生活方式融入中老年日常，为中老年群体创造美好的精神生活。',
			link: 'http://finance.people.com.cn/n1/2025/0828/c1004-40552136.html',
		},
		{
			channelImg:
				'https://media.qianliaowang.com/xqd/tools/activity/image/2025112011/EWIKGC7I-5EF6-NEKA-1763622663426-5U58ZBEJSTQW.png?x-oss-process=image/format,webp',
			title: '新消费图鉴 银发消费“上新” 服务供给加速升级',
			content:
				'2025年11月14日，中央广播电视总台CCTV-13《新闻直播间》聚焦中老年兴趣消费，深度解码了兴趣岛如何通过数字技术赋能兴趣学习，帮助银发族跨越 "数字鸿沟"，开启 "第二人生" 的精彩画卷。央视新闻的关注，既彰显了兴趣岛创新实践的行业价值，更印证了其“以用户为中心” 的核心理念，正与主流价值体系形成深度共鸣。',
			link:
				'https://tv.cctv.com/2025/11/14/VIDEUAElS7GUbjzppUmqyRVr251114.shtml?spm=C53156045404.PKXC0xLPAnP9.0.0',
		},
		{
			channelImg:
				'https://media.qianliaowang.com/qlLive/activity/image/MLOPCT67-GBK4-NWUO-1731044850458-CIQ5JIPXS6PS.png?x-oss-process=image/format,webp',
			title: '东方智慧与现代生活深度融合，兴趣岛武当太极蔚然成风',
			content:
				'10月30日，中宣部新华社《半月谈》发长文深度报道兴趣岛武当太极是东方智慧与现代生活深度融合，据悉，《半月谈》被誉为"中华第一刊"，是中宣部委托新华社主办的重要党刊，本报道对于兴趣岛媒体传播极具影响力。',
			link: 'https://mp.weixin.qq.com/s/Dc6zZ_Nma7hhxnLwMv65DQ',
		},
		{
			channelImg:
				'https://media.qianliaowang.com/qlLive/activity/image/DL9LWEBE-WNBD-16DV-1743676374320-U8UCR3AIZRO5.png?x-oss-process=image/format,webp',
			title: '2025兴趣岛艺术节启幕，深耕银龄文化服务探索"第二人生"无限精彩',
			content:
				'3月28日，央级媒体中国日报网发布报道，讲述2025兴趣岛艺术节现场盛况，聚焦兴趣岛名师更多，指出兴趣岛组建名师团队，通过高质量的专业教学，帮助银龄群体在多个艺术兴趣领域突破自我。',
			link: 'https://cnews.chinadaily.com.cn/a/202503/28/WS67e6384aa31008317a2af1b4.html',
		},
		{
			channelImg:
				'https://media.qianliaowang.com/xqd/tools/activity/image/2026013011/LWGG3T3B-ILYQ-NSLY-1769766325786-FPEUXMUQPFZ1.png',
			title: '央视新闻关注兴趣岛 兴趣岛成行业实践样本',
			content:
				'广州兴趣岛信息科技有限公司联合创始人刘艺：我们企业自成立以来已研发30门视频课程，在线学员达3500万人。咨询情况来看，摄影、瑜伽、太极等课程备受老年用户青睐。',
			link:
				'https://content-static.cctvnews.cctv.com/snow-book/index.html?item_id=17107754974317665045&toc_style_id=feeds_default&track_id=3A35A166-53BB-4B84-A911-319EC956A5F9_784795121525&share_to=wechat',
		},
		{
			channelImg:
				'https://media.qianliaowang.com/xqd/tools/activity/image/2026013011/GVJYIL2R-KQU7-FJZM-1769763842232-7T34BEHXO6CL.png',
			title: '兴趣岛“三师”服务模式 守护银发族学习梦',
			content:
				'兴趣岛创新推出“三师”服务模式，通过名师授课、助教点评、班主任陪伴答疑，构建出一个全方位的学习支持闭环。名师传授专业知识，助教跟踪学习效果、指导技能提升，班主任则负责日常鼓励、情感支持和学习督促——三者协同，为中老年学员提供全程陪伴。',
			link: 'http://www.cctvzyzg.com/index/detail/id/8882.html',
		},
		{
			channelImg:
				'https://media.qianliaowang.com/xqd/tools/activity/image/2026013011/CPJWJ4X5-M5CU-HZWA-1769764014901-BY1ANGQ242XY.png',
			title: '中老年兴趣学习升温 业界助力构建行业良性生态',
			content:
				'兴趣岛副总裁林景在近日举办的第三届消费大赏活动现场提及此现状时表示，作为在线学习平台，兴趣岛对外发布在线兴趣教育服务标准——“九不做”，以规范化举措构建健康的兴趣学习生态。',
			link: 'http://finance.people.com.cn/n1/2025/0704/c1004-40515091.html',
		},
		{
			channelImg:
				'https://media.qianliaowang.com/xqd/tools/activity/image/2026013011/K6RPUN7G-PYGQ-57NE-1769764220469-KGRPOBIR36HZ.png',
			title: '兴趣岛爱心图书室落地四川箭板小学 点亮孩子们的阅读梦',
			content:
				'2025年12月，广州兴趣岛信息科技有限公司向四川省沐川县箭板小学捐赠2763册涵盖文学、科普、童话等类别的优质图书，有效改善了该校阅读资源不足的困境。',
			link: 'http://gd.news.cn/20251224/06b7898a5a384c07b71d1d2ce867064c/c.html',
		},
		{
			channelImg:
				'https://media.qianliaowang.com/xqd/tools/activity/image/2026013011/GXIZAKZN-7XHP-PEFH-1769764288216-RP9ML2XZ5G9N.png',
			title: '从线上课堂到专业舞台的产业实践 师生音乐会解锁银发经济新路径',
			content:
				'2026年1月16日晚，广州南越SYNT演艺中心温情涌动，随着一曲《难忘今宵》的合唱旋律缓缓落下，为期3天的兴趣岛“圆梦时光・宋伶俐新年师生音乐会”圆满落幕。50余位乐龄歌者与兴趣岛唱歌特训营首席讲师、中央民族乐团女中音歌唱家、国家一级演员宋伶俐老师同台献艺，用饱含热爱的歌声，完成了一场从线上课堂到线下舞台的圆梦之约，这是兴趣岛联合兴趣生活研究院打造的专业舞台展演活动。',
			link: 'https://m.itouchtv.cn/video/7d7ea08914e3a170b330bb4d74729119?shareId=VicjEQdE',
		},
		{
			channelImg:
				'https://media.qianliaowang.com/xqd/tools/activity/image/2026013011/34CSES3W-5KI8-QUS7-1769764336120-5LNBY8DX1K8R.png',
			title: '兴趣岛发起“i公益志愿服务计划” 以“研究 + 公益”推动乐龄兴趣文化普惠',
			content:
				'2025 年 10 月 28 日，“2025 广州银龄艺术季颁奖典礼暨优秀节目展演” 在广州粤剧院举行。活动现场，由广州兴趣岛信息科技有限公司直接管理的兴趣岛i公益志愿服务队牵头的 “i公益志愿服务计划” 正式发布，这标志兴趣学习平台兴趣岛将企业社会责任与核心战略深度绑定，以兴趣普惠为核心，精准聚焦老年群体关怀领域。',
			link: 'https://biznews.sohu.com/a/950482469_121198369',
		},
		{
			channelImg:
				'https://media.qianliaowang.com/xqd/tools/activity/image/2026013011/67RFPKDQ-ITMU-D5N3-1769774726951-2SM6W36D5RCQ.png',
			title: '引领行业消费保障新标准，兴趣岛推出“48小时自动退费”服务升级',
			content:
				'兴趣岛作为行业领先的在线兴趣学习品牌，此前发布《在线兴趣学习“九不做”服务倡议》，明确提出九项具体、可执行的服务规范，树立行业自律标杆。2025年9月，其App面向购买体验课程用户的“48小时自动退费”功能正式上线，率先在行业内实现退费自动化，引发广泛关注。',
			link: 'https://caijing.chinadaily.com.cn/a/202509/10/WS68c1364ba310f07257747b62.html',
		},
		{
			channelImg:
				'https://media.qianliaowang.com/xqd/tools/activity/image/2026013011/C2OJJEDY-DM7O-8OCH-1769772957670-4S4W8YJ5CHJ1.png',
			title: '《乐龄族兴趣生活方式图鉴》揭示“无龄感”生活新趋势',
			content:
				'2025年10月29日，一份聚焦40-70岁人群兴趣生活的《乐龄族兴趣生活方式图鉴》（下称《图鉴》）在广州发布。这份由大成人在线兴趣学习平台兴趣岛编制的图鉴，通过超3500万用户的数据调研，描绘了当代乐龄群体突破年龄界限、通过兴趣学习重塑生活方式的新图景。',
			link: 'https://app.gmdaily.cn/as/opened/n/f939e15199ad437ca2d909fcd7f259a6',
		},
		{
			channelImg:
				'https://media.qianliaowang.com/xqd/tools/activity/image/2026013011/JS9TAZVF-T5QX-P14I-1769764615383-U1TJSKN1NBBL.png',
			title: '50多位银发歌者与国家一级演员宋伶俐同台圆梦',
			content:
				'为期三天的兴趣岛“圆梦时光·宋伶俐新年师生音乐会”16日晚在广州南越SYNT演艺中心圆满落幕。当晚，50余位乐龄歌者与兴趣岛唱歌特训营首席讲师、中央民族乐团女中音歌唱家、国家一级演员宋伶俐同台献艺，用歌声完成了一场从线上课堂到线下舞台的圆梦之约。',
			link: 'https://www.gd.chinanews.com.cn/2026/2026-01-20/446204.shtml',
		},
		{
			channelImg:
				'https://media.qianliaowang.com/xqd/tools/activity/image/2026030311/SRFFMW63-SWMI-K23D-1772504945459-G61ABHI72Z23.png',
			title: '兴趣岛学员携手胡乐民，解锁银发群体国家级春晚舞台！',
			content:
				'2026年2月10日，正值北方小年，“骏马迎春·福满神州”2026春节联欢晚会在中央新影中学生频道正式首播。来自兴趣学习平台兴趣岛的10位朗诵学员，携手中国著名朗诵家、兴趣岛朗诵营首席讲师胡乐民，共同演绎的朗诵节目《美丽中国》，在全国众多作品中脱颖而出，成功登上这一高端春晚舞台。晚会上，狼戈、陈红、刘兰芳、祁隆、金波等嘉宾倾情助阵，让银发群体的平凡热爱在国家级媒体的春晚舞台上绽放光彩。',
			link: 'http://www.takungpao.cn/special/239159/2026/0210/1156391.html',
		},
	];

	const onSlidePrev = () => {
		swipeRef.current?.slidePrev?.();
	};

	const onSlideNext = () => {
		swipeRef.current?.slideNext?.();
	};

	const changeAutoPlay = () => {
		if (!swipeRef.current.autoplay.running) {
			swipeRef.current.autoplay?.start?.();
		} else {
			swipeRef.current.autoplay?.stop?.();
		}
	};

	const getSwipeInstance = (swiper) => {
		swipeRef.current = swiper;
	};

	return (
		<div className={`home-brand-report-container ${classNames}`}>
			<div className="brand-report-list">
				<div className="brand-report-prev flex-center" onClick={onSlidePrev}>
					<i className="iconfont iconxiaojiantou to-left"></i>
				</div>
				<div className="brand-report-next flex-center" onClick={onSlideNext}>
					<i className="iconfont iconxiaojiantou"></i>
				</div>
				<Swiper
					onSwiper={getSwipeInstance}
					// navigation={true}
					slidesPerView="auto"
					loop={true}
					observer
					observeParents
					observeSlideChildren
					centeredSlides
					spaceBetween={48}
					autoplay={{
						delay: 5000,
						disableOnInteraction: false,
					}}
					className="brand-report-swiper"
				>
					{list.map((item: any, index: number): any => (
						<SwiperSlide key={index} className="brand-report-slide">
							<div
								className="brand-report-item"
								key={index}
								onMouseOver={changeAutoPlay}
								onMouseOut={changeAutoPlay}
								onClick={() => window.open(item?.link)}
							>
								<div className="report-item-wrap">
									<img className="channel-img" src={item.channelImg} />
									<div className="title">{item.title}</div>
									<div className="content">{item.content}</div>
								</div>
								<div className="view-detail-text flex-center">
									查看详情
									<i className="iconfont iconxiaojiantou"></i>
								</div>
							</div>
						</SwiperSlide>
					))}
				</Swiper>
			</div>
		</div>
	);
};
export default BrandReport;
